import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { HeaderSection } from '../layout/HeaderSection';
import Footer from '../layout/Footer';
import { useIsAuthenticated } from '@azure/msal-react';


const Layout: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const isLoginView = !isAuthenticated && location.pathname === '/';

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <HeaderSection />
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: isLoginView ? 'center' : undefined,
        }}
      >
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
